import { probeSharePointBackend } from '../app-globals.js';
/**
 * Portal Manta · SP_API
 * Extraído de App.jsx v29.3 (via AST)
 */
const SP_API = (() => {
  const base = (typeof window !== 'undefined' && window.MANTA_BACKEND_URL) || 'http://localhost:3001';
  return {
    base,
    enabled: false, // setado por probeSharePointBackend()
    async probe(){
      try {
        const r = await fetch(base + '/api/sharepoint/health', {method:'GET', signal: AbortSignal.timeout(2000)});
        if (r.ok) { this.enabled = true; return {ok:true, base}; }
        this.enabled = false; return {ok:false, status:r.status};
      } catch(e){ this.enabled = false; return {ok:false, erro:e.message}; }
    },
    async fetchFile(uri){
      if (!this.enabled) throw new Error('Backend SharePoint OFF · use modo manual');
      const r = await fetch(base + '/api/sharepoint/file?uri=' + encodeURIComponent(uri));
      if (!r.ok) throw new Error('Backend retornou ' + r.status);
      return await r.json();
    },
  };
})();

export { SP_API };
export default SP_API;
